import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

const NavigationItem = ({ ...props }) => {
  const itemClass = props.isActive ? 'nav-active' : 'nav-inactive';
  const positiveCount = (props.totalItemsCount > 0);

  return (
    <a className={itemClass} onClick={() => { props.changeActiveItem(props.name); props.history.push(props.href); }}>
      <i className={props.icon}>
        {
          props.displayCount && positiveCount && <small>{props.totalItemsCount}</small>
        }
      </i>
      <span>{props.name}</span>
    </a>
  );
};

NavigationItem.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  changeActiveItem: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  displayCount: PropTypes.bool.isRequired,
  totalItemsCount: PropTypes.number.isRequired
};

export default connect((state) => ({}), (dispatch) => ({}))(withRouter(NavigationItem));
